/**
 * Amazon 画像ライブラリ（2026-10-06〜）。
 * 画像の正本は Cloudflare Pages「stoq-amazon-media」（無圧縮・自社管理）。公開時に amazon/images/build-manifest.py が
 * manifest.json（画像一覧）を書き出し、コンソールはそれを直接読む（CORS 許可済み・読み取り専用）。
 * 画像の追加・差し替えはリポジトリ側（amazon/images/publish → wrangler pages deploy）で行う。
 * ※ types/amazon.ts は stoq-worker と同期しているため、こちらはコンソール専用の別ファイルにしている。
 */
export const AMZ_MEDIA_BASE = "https://stoq-amazon-media.pages.dev/";

export interface AmzMediaItem {
  file: string;
  url: string;
  /** ファイル名から取った SKU（規約外の名前は ""） */
  sku: string;
  /** "main" または 2桁の枠番号（"02" = Amazon の2枚目） */
  slot: string;
  /** 並び順（main=1, "02"=2 …） */
  order: number;
  version: number;
  /** 同じ SKU×枠 の中で最新版か */
  latest: boolean;
  width: number;
  height: number;
  bytes: number;
  caption?: string;
  publishedAt?: string;
}

export interface AmzMediaManifest {
  base: string;
  generatedAt: string;
  items: AmzMediaItem[];
}
